import {
    LegalDocsMetadata,
    type LegalDocMetadata,
} from "@logscord/public-site-config";
import { getClientPublicContent } from "./contentRegistry.js";


//////////////////////////////////////////////////
//  LEGAL CONTENT
//////////////////////////////////////////////////


export type LegalDoc = LegalDocMetadata;

export const LegalDocs: readonly LegalDoc[] = LegalDocsMetadata;

export function getLegalDoc(slug: string): LegalDoc | undefined {
    return LegalDocs.find((doc) => doc.slug === slug);
}

export function getLegalDocContent(doc: LegalDoc, locale: string) {
    return getClientPublicContent(doc.contentKey, locale);
}
